import GraphqlBaseService from './GraphqlBaseService'
import { campaignRecordsRemainingQuery, campaignCohortsQuery } from '../graphql/campaign'

class CampaignService extends GraphqlBaseService {
  /**
   * Get the number of records that this campaign can still upload.
   * @return {Promise<null|Integer>}
   */
  getRecordsRemainingCount () {
    return this.query({
      query: campaignRecordsRemainingQuery,
      fetchPolicy: 'network-only'
    }, 'campaignRecordsRemaining')
  }

  /**
   * Get the Cohorts for this campaign
   * @returns {Promise}
   */
  getCampaignCohorts () {
    return this.query({
      query: campaignCohortsQuery,
      fetchPolicy: 'network-only'
    }, 'campaignCohorts')
  }

  /**
   * Check if the current campaign is in a specific cohort
   * @param cohortName
   * @returns {Promise<*>}
   */
  async isCampaignInCohort (cohortName) {
    const cohorts = await this.getCampaignCohorts()
    const cohort = cohorts && cohorts.find(cohort => cohort.name === cohortName)
    return !!cohort
  }
}

export default new CampaignService()
